import questionsData from './html5-applications/questions-data';
import practiceTestData from './html5-applications/practice-test';

export const getQuestions = () => {
  return Promise.resolve(questionsData);
};

export const getPracticeTest = () => {
  return Promise.resolve(practiceTestData);
};